import { Action, createReducer, on } from '@ngrx/store';
import { IDistributionChart } from '../models/user-analytics.model';
import * as actions from '../actions';

export const getFundingStatusByAgeScatterChartKey = 'getFundingStatusByAgeScatterChart';
export interface FundingStatusByAgeScatterChartState {
  loadFundingStatusByAgeScatterChartResponse: IDistributionChart[];
  loadFundingStatusByAgeScatterChartResponseFailure: any;
  loaded: boolean;
}

export const initialState: FundingStatusByAgeScatterChartState = {
  loadFundingStatusByAgeScatterChartResponse: undefined,
  loadFundingStatusByAgeScatterChartResponseFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadFundingStatusByAgeScatterChart, (state, action) => ({
    ...state
  })),
  on(actions.loadFundingStatusByAgeScatterChartSuccess, (state, action) => ({
    ...state,
    loadFundingStatusByAgeScatterChartResponse: action.response,
    loaded: true
  })),
  on(actions.loadFundingStatusByAgeScatterChartFailure, (state, action) => ({
    ...state,
    loadFundingStatusByAgeScatterChartResponseFailure: action.error
  }))
);

export const getFundingStatusByAgeScatterChart = (state: FundingStatusByAgeScatterChartState) => {
  if (state && state.loadFundingStatusByAgeScatterChartResponse)
    return JSON.parse(JSON.stringify(state.loadFundingStatusByAgeScatterChartResponse));
  else return null;
};

export const getFundingStatusByAgeScatterChartIsLoaded = (state: FundingStatusByAgeScatterChartState) => {
  state.loaded;
};
